import {Activity, Occasion} from "../state";

declare var NeoData: any;
export function parseAllActivities():Activity[]{
	var initData = [];
	try{
		initData =  NeoData.data.activities || [];
		initData = initData.map((e)=>{
			return {...e,id:parseInt(e.id)};
		});
	}catch (e){
		console.log(`[NR] Parsing NeoData failed.`);
	}
	return initData;
}
export function parseAllOccasions(){
	var ret = [];
	try{
		var initData =  NeoData.data.occasions || [];
		var childrenByParent = {};
		initData.forEach((c)=>{
			if(c.parent == 0) return;
			if(!childrenByParent[c.parent]) childrenByParent[c.parent] = [];
			childrenByParent[c.parent].push(c);
		});
		
		var parents = initData.filter((a)=>a.parent == 0);
		parents.forEach((p:Occasion)=>{
			if(childrenByParent[p.id]){
				p.variants = childrenByParent[p.id].map((a)=>a.name);
			}else{
				p.variants = [];
			}
			ret.push({...p,id:parseInt(p.id + '')});
		});
	}catch (e){
		console.log(`[NR] Parsing NeoData failed.`);
	}
	return ret;
}

/**Deletes an element and returns a copy of the array. useful for state management*/
export function arrayDelCopy<T>(array:Array<T>, elToDelete:T):Array<T>{
    var idx = array.indexOf(elToDelete);
    const shallowCopy = [...array];
    if(idx != -1) shallowCopy.splice(idx,1);
    return shallowCopy;
}


var scrollCallbacks:Array<()=>void> = [];
const listener = ()=>{
    scrollCallbacks.forEach((k)=>{
        k();
    })
    scrollCallbacks = [];
    window.removeEventListener('scroll',listener)
};
export function addScrollAwayCallback(callback:()=>void){
    scrollCallbacks.push(callback);
    if(scrollCallbacks.length == 1)
        window.addEventListener('scroll',listener)
}